import { ChangeDetectionStrategy, Component, signal } from "@angular/core";

@Component({
    selector: 'medsurf-shortcuts',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './shortcuts.component.html',
    styleUrls: ['./shortcuts.component.scss'],
    standalone: false
})
export class ShortcutsComponent {
  isOpened = signal(false);

  public togglePopup(open?: boolean) {
    if (typeof open === 'boolean') {
      this.isOpened.set(open);
    } else {
      this.isOpened.set(!this.isOpened());
    }
  }
}
